import cache from "./cache";

const inMemoryCache = cache();

const withCache =
  fn =>
  (url, params, ...rest) => {
    const { cacheable } = params || {};
    const key = [url, params, ...rest];
    if (cacheable) {
      const data = inMemoryCache.read(key);
      if (data) return Promise.resolve(data);
    }
    return fn(url, params, ...rest).then(json => {
      if (cacheable) {
        inMemoryCache.write(key, json);
      }
      return json;
    });
  };

export default withCache;
